<div
  *ngIf="visible && subscriptionsEnabled"
  class="container-notification"
  [class.container-notification--info-only]="!showActions"
>
  <div class="box-message">
    <ng-lottie width="51px" height="59px" [options]="options"></ng-lottie>
    <span class="message" [ngStyle]="{ 'flex-direction': flexDirection }">
      <p style="font-size: 16px; font-weight: 600">{{ title }}</p>
      <p *ngIf="subtitle" style="font-size: 14px; font-weight: 500">{{ subtitle }}</p>
    </span>
    <button *ngIf="showCloseButton" class="close-button close-mobile" (click)="closeNotification()">
      <i class="pi pi-times"></i>
    </button>
  </div>

  <div *ngIf="showActions" class="buttons">
    <button *ngIf="showCtaButton" class="btn-pay" (click)="onCtaClick()">{{ ctaLabel }}</button>
    <button
      *ngIf="showCloseButton"
      class="close-button close-desktop"
      (click)="closeNotification()"
    >
      <i class="pi pi-times"></i>
    </button>
  </div>
</div>
